/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { AaiSecurityScheme } from '../../models/AaiSecurityScheme';
import { Node } from '../../../core/models/Node';

/**
 * Constructor.
 * @param {Node} parent
 * @param {string} name
 * @class
 * @extends AaiSecurityScheme
 * @author Jakub Senko<jsenko@redhat.com>
 */
export class Aai20SecurityScheme extends AaiSecurityScheme {
    public constructor(parent? : any, name? : any) {
        if(((parent != null && parent instanceof <any>Node) || parent === null) && ((typeof name === 'string') || name === null)) {
            let __args = arguments;
            super(parent, name);
        } else if(((typeof parent === 'string') || parent === null) && name === undefined) {
            let __args = arguments;
            let name : any = __args[0];
            super(name);
        } else if(((parent != null && parent instanceof <any>Node) || parent === null) && name === undefined) {
            let __args = arguments;
            super(parent);
        } else throw new Error('invalid overload');
    }
}
Aai20SecurityScheme["__class"] = "io.apicurio.datamodels.asyncapi.v2.models.Aai20SecurityScheme";
Aai20SecurityScheme["__interfaces"] = ["io.apicurio.datamodels.core.models.common.IDefinition","io.apicurio.datamodels.core.models.IVisitable","io.apicurio.datamodels.core.models.IReferenceNode","io.apicurio.datamodels.core.models.common.INamed"];




